import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeof',
  standalone: false,
})
export class TypeofPipe implements PipeTransform {
  public transform(value: unknown, ...args: unknown[]): typeof value {
    return typeof value;
  }
}
